import { MaskedTextBox, MaskedTextBoxChangeEvent } from "@progress/kendo-react-inputs"
import { useState } from "react"

export interface LabPhoneNumberProps {
    labPhoneNumber: string,
    setValue: Function,
    children?: React.ReactNode
}

export const LabPhoneNumber = (props: LabPhoneNumberProps) => {
    const [value, setValue] = useState(props.labPhoneNumber);
    const onChange = (e: MaskedTextBoxChangeEvent) => {
        setValue(e.value);
        props.setValue(e.value);
    }

    return <MaskedTextBox defaultValue="___-___-____" required={true} mask="000-000-0000" value={value} onChange={onChange}></MaskedTextBox>
}